// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__31Yj8","actionsCol":"EnrolledClinics_actionsCol__MYPT-"};